export type KundaliLang = "en" | "hi";

export interface KundaliTranslations {
  name: string;
  birthDate: string;
  birthTime: string;
  birthPlace: string;
  optional: string;
  timeUnknownToggle: string;
  timeUnknownExplainer: string;
  submit: string;
  namePlaceholder: string;
  placePlaceholder: string;
  savedNote: string;
  loading: string;
  phone: string;
  phonePlaceholder: string;
  phoneCountryLabel: string;
  phoneReason: string;
  email: string;
  emailPlaceholder: string;
  emailToggle: string;
  placeChange: string;
  placeDidYouMean: string;
  retryTitle: string;
  retryBody: string;
  retryAction: string;
}

const DEFAULT_TRANSLATIONS: Record<KundaliLang, KundaliTranslations> = {
  en: {
    name: "Your Name",
    birthDate: "Birth Date",
    birthTime: "Birth Time",
    birthPlace: "Birth Place",
    optional: "(optional)",
    timeUnknownToggle: "Don't know your birth time?",
    timeUnknownExplainer:
      "No problem — we'll read the planets with a noon default, which holds true for your rashi and nakshatra. One honest note: your Lagna, houses, and dasha cannot be read without the exact time.",
    submit: "Generate Free Kundali →",
    namePlaceholder: "Enter your full name",
    placePlaceholder: "City, State (e.g. Chennai, Tamil Nadu)",
    savedNote: "Your reading is saved securely so you can access it anytime.",
    loading: "Calculating your stars...",
    phone: "WhatsApp mobile number",
    phonePlaceholder: "98765 43210",
    phoneCountryLabel: "Country code",
    phoneReason:
      "Required for your saved Kundali and returning access. It does not opt you into marketing.",
    email: "Email",
    emailPlaceholder: "you@example.com (optional)",
    emailToggle: "Add an email backup (optional)",
    placeChange: "Change",
    placeDidYouMean: "Did you mean",
    retryTitle: "Couldn't reach the stars just now",
    retryBody: "Your details are saved. The connection slipped — tap to try once more.",
    retryAction: "Try again",
  },
  // Native Hinglish (Roman) — the verified brand register (rule 21: single Indian noun
  // + English action word; pure Devanagari compounds score 0). These labels were
  // Devanagari while this same form's error messages were already Hinglish — a register
  // split inside one form, on the exact surface where the plan's #1 failure class
  // concentrates (birthPlace). The Devanagari place-hint reads in a script the brand
  // register says converts ~0. scripts/check_hindi_register.py blocks Devanagari here.
  hi: {
    name: "Aapka naam",
    birthDate: "Janm tithi",
    birthTime: "Janm samay",
    birthPlace: "Janm sthal",
    optional: "(optional)",
    timeUnknownToggle: "Janm samay nahi pata?",
    timeUnknownExplainer:
      "Koi baat nahi — hum dopahar 12 baje maankar graha sthiti nikaal denge, jo rashi aur nakshatra ke liye sahi rehti hai. Par dhyaan rahe: Lagna, bhaav aur dasha sahi janm samay ke bina nahi bataye ja sakte.",
    submit: "Free Kundali banayein →",
    namePlaceholder: "Apna pura naam likhein",
    placePlaceholder: "Sheher, state (jaise Chennai, Tamil Nadu)",
    savedNote: "Aapki kundali securely save hoti hai, kabhi bhi dekh sakte hain.",
    loading: "Aapke graha calculate ho rahe hain...",
    phone: "WhatsApp mobile number",
    phonePlaceholder: "98765 43210",
    phoneCountryLabel: "Country code",
    phoneReason:
      "Saved Kundali aur returning access ke liye required. Marketing opt-in alag hota hai.",
    email: "Email",
    emailPlaceholder: "you@example.com (optional)",
    emailToggle: "Email backup add karein (optional)",
    placeChange: "Badlein",
    placeDidYouMean: "Kya aapka matlab tha",
    retryTitle: "Abhi taaron tak nahi pahunch paaye",
    retryBody: "Aapki details safe hain. Connection toot gaya — ek baar phir try karein.",
    retryAction: "Phir try karein",
  },
};

export function getKundaliTranslations(
  language: KundaliLang,
  overrides: {
    submitLabel?: string;
    savedNote?: string;
    loadingLabel?: string;
    namePlaceholder?: string;
    placePlaceholder?: string;
    phoneReason?: string;
  } = {}
): KundaliTranslations {
  const defaults = DEFAULT_TRANSLATIONS[language];
  return {
    ...defaults,
    submit: overrides.submitLabel || defaults.submit,
    namePlaceholder: overrides.namePlaceholder || defaults.namePlaceholder,
    placePlaceholder: overrides.placePlaceholder || defaults.placePlaceholder,
    phoneReason: overrides.phoneReason || defaults.phoneReason,
    savedNote: overrides.savedNote || defaults.savedNote,
    loading: overrides.loadingLabel || defaults.loading,
  };
}
